<template>
	<Layout :loading="saving" :pageTitle="'Mi perfil'">
		<template #cta>
			<router-link tag="a" :to="`${$route.path}/create`" class="btn btn-link">Cambiar contraseña</router-link>
		</template>

		<Loader :show="loading" type="inline" />

		<div class="main-container" v-if="!loading">
			<div class="card mt-2">
				<div class="card-body">
					<FormulateForm ref="form" v-model="form" @submit="save">
						<FormulateInput label="Nombre" name="name" validation-name="Nombre" validation="required" />

						<FormulateInput
							label="Apellido"
							name="lastname"
							validation-name="Apellido"
							validation="required"
						/>

						<FormulateInput
							label="Email"
							type="email"
							name="email"
							validation-name="Email"
							validation="required"
						/>

						<div class="d-flex justify-content-between mt-4">
							<FormulateInput type="button" data-ghost @click="$router.go(-1)">Cancelar</FormulateInput>
							<FormulateInput type="button" disabled v-if="saving"
								>Guardando <span class="loader"
							/></FormulateInput>
							<FormulateInput type="submit" label="Actualizar datos" v-else />
						</div>
					</FormulateForm>
				</div>
			</div>
		</div>
	</Layout>
</template>

<script>
import { mapMutations, mapGetters } from "vuex"
import gql from "graphql-tag"
import mixins from "@/mixins/mixins"
import formMixins from "@/mixins/formMixins"

export default {
	name: "Account",
	mixins: [mixins, formMixins],
	computed: {
		...mapGetters(["loggedUser"])
	},
	beforeMount() {
		this.load()
	},
	data() {
		return {
			loading: true,
			saving: false,
			form: {
				avatar: null,
				name: null,
				lastname: null,
				email: null
			}
		}
	},
	methods: {
		...mapMutations(["updateLoggedUser"]),
		save() {
			if (!this.saving) {
				this.saving = true
				let dataInput = {
					avatar: this.form.avatar.id || null,
					name: this.form.name,
					lastname: this.form.lastname,
					email: this.form.email
				}
				this.update(dataInput)
			}
		},
		update(dataInput) {
			this.$apollo
				.mutate({
					mutation: gql`
						mutation($id: ID!, $data: UserInput!) {
							userUpdate(id: $id, data: $data) {
								id
								name
								lastname
								email
								avatar {
									filename
									url
									urlThumb
								}
							}
						}
					`,
					variables: {
						id: this.loggedUser.id,
						data: dataInput
					}
				})
				.then(({ data }) => {
					this.$toast.success("Perfil actualizado correctamente")
					this.saving = false

					// actualizo lso datos en store
					this.updateLoggedUser(data.userUpdate)
				})
				.catch((error) => {
					this.errors = this.parseGQLErrors(error)
					this.saving = false
				})
		},
		load() {
			this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							user(id: $id) {
								id
								name
								lastname
								email
								avatar {
									id
									filename
									url
									urlThumb
								}
							}
						}
					`,
					variables: { id: this.loggedUser.id },
					fetchPolicy: "no-cache"
				})
				.then(({ data }) => {
					this.form = {
						...data.user
					}
					this.loading = false
				})
				.catch((err) => {
					this.$toast.success("El item que desea editar no existe")
					this.$router.go(-1)
				})
		}
	}
}
</script>

<style></style>
